<div class="m-center-text l_flex-shrink">
  <dgx-follow-user-button
    [hasPromise]="true"
    [isActive]="isViewersFollowee()"
    (onToggle)="toggleFollowUser()"
    [submitting]="submitting"
    [buttonClasses]="buttonClasses"
    [showFollowingLabel]="showFollowingLabel"
  >
  </dgx-follow-user-button>
</div>
